module.exports = __webpack_public_path__ + "static/media/hamburger-nav-icon.2517b99e.svg";